'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _modalify = require('../utilities/modalify');

var _modalify2 = _interopRequireDefault(_modalify);

var _timeout = require('../utilities/timeout');

var _timeout2 = _interopRequireDefault(_timeout);

var _walletTypes = require('../utilities/walletTypes');

var _PaymentTerminal = require('../components/wallet/PaymentTerminal');

var _PaymentTerminal2 = _interopRequireDefault(_PaymentTerminal);

var _PaymentExplanation = require('../components/wallet/PaymentExplanation');

var _PaymentExplanation2 = _interopRequireDefault(_PaymentExplanation);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultViewOptions = {
  title: 'Confirm Transaction',
  message: 'One line description of what it does'
};

var EthGateway = function () {
  function EthGateway(walletManager, notifications) {
    _classCallCheck(this, EthGateway);

    this.walletManager = walletManager;
    this.notifications = notifications;
  }

  /**
   * Processes a payment, interacting with the UI for prompt
   *
   * @param {Function} getState - returns state from store
   * @param {Object} txOptions - transaction object created from contract
   * @return {Promise} containing result from send transaction, or null on abort/fail
   */


  _createClass(EthGateway, [{
    key: 'process',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(getState, txOptions) {
        var _this = this;

        var _getState, _getState$account, walletType, address, wallet, _txOptions$create, create, _txOptions$onStart, onStart, _txOptions$onSuccess, onSuccess, _txOptions$onError, onError, _txOptions$onAbort, onAbort, _txOptions$viewOption, viewOptions, _txOptions$returnOnRe, returnOnReceipt, walletInfo, walletTransactionTimeout, tx, sender, modalOptions, confirmed, confirmationModal, triggerClose, closeWrapper;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _getState = getState(), _getState$account = _getState.account, walletType = _getState$account.walletType, address = _getState$account.address;
                wallet = this.walletManager.get(walletType, address);
                _txOptions$create = txOptions.create, create = _txOptions$create === undefined ? _lodash.noop : _txOptions$create, _txOptions$onStart = txOptions.onStart, onStart = _txOptions$onStart === undefined ? _lodash.noop : _txOptions$onStart, _txOptions$onSuccess = txOptions.onSuccess, onSuccess = _txOptions$onSuccess === undefined ? _lodash.noop : _txOptions$onSuccess, _txOptions$onError = txOptions.onError, onError = _txOptions$onError === undefined ? _lodash.noop : _txOptions$onError, _txOptions$onAbort = txOptions.onAbort, onAbort = _txOptions$onAbort === undefined ? _lodash.noop : _txOptions$onAbort, _txOptions$viewOption = txOptions.viewOptions, viewOptions = _txOptions$viewOption === undefined ? _extends({}, defaultViewOptions) : _txOptions$viewOption, _txOptions$returnOnRe = txOptions.returnOnReceipt, returnOnReceipt = _txOptions$returnOnRe === undefined ? false : _txOptions$returnOnRe;
                walletInfo = _walletTypes.walletDefinitions.find(function (def) {
                  return def.type === walletType;
                });
                walletTransactionTimeout = walletInfo.timeout;
                _context2.next = 7;
                return create();

              case 7:
                tx = _context2.sent;

                if (!(0, _lodash.isEmpty)(tx)) {
                  _context2.next = 11;
                  break;
                }

                onAbort();
                return _context2.abrupt('return', null);

              case 11:
                sender = function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    var txHash;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;

                            onStart();

                            // pre-flight check
                            _context.prev = 2;
                            _context.next = 5;
                            return (0, _timeout2.default)(wallet.getAddress(), _constants.PREFLIGHT_TIMEOUT_MS);

                          case 5:
                            _context.next = 12;
                            break;

                          case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](2);

                            _this.notifications.error('We could not establish a connection to your wallet.');
                            onAbort();
                            return _context.abrupt('return', null);

                          case 12:
                            _context.next = 14;
                            return (0, _timeout2.default)(wallet.sendTransaction({
                              from: tx.sendOptions.from,
                              to: tx.contract,
                              value: tx.sendOptions.value,
                              data: tx.transaction.encodeABI(),
                              gas: tx.sendOptions.gas,
                              gasPrice: tx.sendOptions.gasPrice
                            }, returnOnReceipt), walletTransactionTimeout);

                          case 14:
                            txHash = _context.sent;

                            onSuccess(txHash);
                            return _context.abrupt('return', txHash);

                          case 19:
                            _context.prev = 19;
                            _context.t1 = _context['catch'](0);

                            if (!(_context.t1.name === 'TimeoutError')) {
                              _context.next = 25;
                              break;
                            }

                            onAbort();
                            _this.notifications.warn('Transaction timed out. Please try again.');
                            return _context.abrupt('return', null);

                          case 25:
                            if (!(_context.t1.name === _constants.USER_REJECTED_TRANSACTION_ERROR)) {
                              _context.next = 28;
                              break;
                            }

                            onAbort();
                            return _context.abrupt('return', null);

                          case 28:
                            onError(_context.t1);
                            return _context.abrupt('return', null);

                          case 30:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[0, 19], [2, 7]]);
                  }));

                  return function sender() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                modalOptions = {
                  transaction: _extends({}, tx, {
                    data: tx.transaction.encodeABI()
                  }),
                  walletType: walletType,
                  walletOptions: { address: address },
                  viewOptions: viewOptions
                };
                confirmed = true;

                if (tx.skipConfirmation) {
                  _context2.next = 19;
                  break;
                }

                confirmationModal = (0, _modalify2.default)(_PaymentExplanation2.default);
                _context2.next = 18;
                return confirmationModal(modalOptions);

              case 18:
                confirmed = _context2.sent;

              case 19:
                if (!confirmed) {
                  _context2.next = 34;
                  break;
                }

                triggerClose = void 0;

                closeWrapper = function closeWrapper(actualCloseFunction) {
                  triggerClose = actualCloseFunction;
                };
                // external wallet


                if (walletInfo.isInteractive) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 25;
                return (0, _modalify2.default)(_PaymentTerminal2.default)(modalOptions);

              case 25:
                return _context2.abrupt('return', null);

              case 26:

                // interactive wallets
                (0, _modalify2.default)(_PaymentTerminal2.default)(_extends({}, modalOptions, {
                  closeOnOverlayClick: false,
                  closeOnEsc: false,
                  showCloseButton: false,
                  passClose: function passClose(close) {
                    return closeWrapper(close);
                  }
                }));

                _context2.prev = 27;
                _context2.next = 30;
                return sender();

              case 30:
                return _context2.abrupt('return', _context2.sent);

              case 31:
                _context2.prev = 31;

                if (triggerClose) triggerClose();
                return _context2.finish(31);

              case 34:

                onAbort();
                return _context2.abrupt('return', null);

              case 36:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[27,, 31, 34]]);
      }));

      function process(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return process;
    }()
  }]);

  return EthGateway;
}();

exports.default = EthGateway;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/EthGateway.js
// module id = 1261
// module chunks = 0